/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export var STATE_CHANGE_TYPE = {
  change: 'change'
};
export var CUSTOM_INPUT_TYPE = {
  textarea: 'textarea'
};
export var ADJOINED = {
  none: 'none',
  left: 'left',
  right: 'right',
  both: 'both'
};
export var SIZE = {
  mini: 'mini',
  default: 'default',
  compact: 'compact',
  large: 'large'
};
export var ENHANCER_POSITION = {
  start: 'start',
  end: 'end'
};